//#region Libraries
import { useState } from "react";
import { useEffect } from "react";
//#endregion
//#region Styles
import { 
    Column,
    Row,
    TitleSection } from "components/styles";
import { 
    Container, Content, Footer } from "./styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlert from "components/DialogAlert/DialogAlert";
import CloseButton from "components/CloseButton/CloseButton";
import CustomTime from "components/CustomTimePicker/CustomTimePicker";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import { useCheckNonExpiredOnlyDayDuration } from "views/Eventos/components/FormCreateEvent/ManualLoadingForm/utils/hooks/useCheckNonExpiredDuration";
//#endregion

const ERROR_TEXTS = {
    INVALID_SCHEDULE_TIME: "Las horas son iguales o la hora de inicio es mayor a la de fin.",
    INVALID_CROSSING_SCHEDULE: "El horario seleccionado ya está ocupado por otro día."
};

const getInitForm = currentDateCarryOutAnAction => {
    const { date, time } = currentDateCarryOutAnAction;
    const newForm = {
        date: date.value,
        time: { ...time.value }
    };
    return {
        value: { ...newForm },
        copy: { ...newForm }
    };
}

const DialogAlertUpdateDate = ({
    show,
    toggleShow,
    currentDateCarryOutAnAction,
    setCurrentDateCarryOutAnAction,
    updateEventDate
}) => {
    //#region States
    const [form, setForm] = useState(null);
    const [error, setError] = useState({
        text: ERROR_TEXTS.INVALID_SCHEDULE_TIME,
        value: false
    });
    //#endregion
    //#region Effects
    useEffect(() => {
    }, []);
    useEffect(() => {
        // Limpiando si se cierra el modal
        if (!show) {
            clearForm();
            return;
        }
        // Setteando valores del registro de fecha actual en el form
        setForm(getInitForm(currentDateCarryOutAnAction));
    }, [show]);
    useEffect(() => {
        if (!form) return;
        const { date, time } = form.value;
        setCurrentDateCarryOutAnAction(prev => ({
            ...prev,
            date: {
                ...prev.date,
                value: date
            },
            time: {
                ...prev.time,
                value: { ...time }
            }
        }));
    }, [form]);
    //#endregion
    //#region Functions
    const changeField = (key, value) => {
        setForm(prev => ({
            ...prev,
            value: {
                ...prev.value,
                [key]: value
            }
        }));
        setError({
            ...error,
            value: false
        });
    }
    const changeTime = (key, value) => {
        changeField("time", {
            ...form.value.time,
            [key]: value
        });
    }
    const getTimePointToFormControl = key => {
        return currentDateCarryOutAnAction.time.value[key];
    }
    const clearForm = () => {
        if (!form) return;
        setForm(prev => ({
            ...prev,
            value: { ...prev.copy }
        }));
        setError({
            ...error,
            value: false
        })
    }
    const checkNonExpiredOnlyDayDuration = useCheckNonExpiredOnlyDayDuration({ 
        duration: form?.value, editionStarted: show
    });
    const update = async () => {
        if (!checkNonExpiredOnlyDayDuration()) 
            return;
        // Revisando si las horas son inválidas
        if (form.value.time.start >= form.value.time.end) {
            setError({
                text: ERROR_TEXTS.INVALID_SCHEDULE_TIME,
                value: true
            });
            return;
        }
        // Delegando actualización a la función llegada del padre
        const errorType = await updateEventDate();
        // Revisando si no hubo error
        if (!errorType) return;
        setError({
            text: ERROR_TEXTS[errorType],
            value: true
        });
    }
    //#endregion
    return (
        <>
        <DialogAlert 
            show={show}
            toggleShow={() => toggleShow()}
            onClose>
            <CloseButton onClick={() => toggleShow()}/>
            <Container>
                <TitleSection 
                    textAlign="center" 
                    fontWeight="900">Edición de evento</TitleSection>
                <Content>
                    <Column width="max-content">
                        <Row width="max-content">
                            <CustomTime 
                                label="Desde:"
                                caption="Desde:"
                                value={getTimePointToFormControl("start")}
                                onChange={value => changeTime("start", value)}
                                error={error.value}/>
                            <CustomTime 
                                label="Hasta:"
                                caption="Hasta:"
                                value={getTimePointToFormControl("end")}
                                onChange={value => changeTime("end", value)}
                                error={error.value}/>
                        </Row>
                        <ErrorMessage 
                            error={error.value}
                            text={error.text}/>
                    </Column>
                    <CustomDatePicker 
                        label="Fecha"
                        value={currentDateCarryOutAnAction.date.value}
                        onChange={value => changeField("date", value)}
                        error={error.value}/>
                </Content>
                <Footer>
                    <CustomButton 
                        text="Sí, cambiar"
                        onClick={update}/>
                    <CustomButton 
                        variant="secondary"
                        text="No cancelar"
                        onClick={() => toggleShow(false)}/>
                </Footer>
            </Container>
        </DialogAlert>
        </>
    );
}

export default DialogAlertUpdateDate;